export class GetManagementByIdSectorUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(ID_SECTOR){
    return await this.repository.getByIdSector(ID_SECTOR)
  }
}
